












import TermSuggestion from '@empathybroker/ebx-gluon/dist/components/pure/suggestions/term-suggestion.vue';
import { Component } from 'vue-property-decorator';

@Component
export default class CdlTermSuggestion extends TermSuggestion {}
